const generateId = () => btoa(window.crypto.randomUUID());

const STORAGE_KEY = "persistent-cart-gid";
let currentGuestId = null;

export default function guestId() {
  if (window.theme.customer_id) return null;

  try {
    if (currentGuestId) return currentGuestId;

    const id = window.localStorage.getItem(STORAGE_KEY);
    if (id) {
      currentGuestId = id;
      return currentGuestId;
    }

    const newId = generateId();
    window.localStorage.setItem(STORAGE_KEY, newId);
    currentGuestId = newId;
    return currentGuestId;
  } catch (error) {
    return null;
  }
}
